import { render } from "./MemoruSetting.vue?vue&type=template&id=70da5979&ts=true"
import script from "./MemoruSetting.vue?vue&type=script&lang=ts"
export * from "./MemoruSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__